// extracted by mini-css-extract-plugin
export default {"myCancerContainer":"WidgetWithButton_myCancerContainer__cK4PZ","title":"WidgetWithButton_title__lrkfw"};